function updateCartPrice(operation, value) {
    const current = Number(localStorage.getItem('cartprice'));
    const input = Number(value);

    if (isNaN(input)) {
        // input value is invalid, do nothing or maybe throw an error
        return;
    }

    let newCartPrice;

    if (isNaN(current) || !current) {
        // Cart price is empty or not a number, just set to input value
        newCartPrice = input;
    } else if (operation === 'add') {
        newCartPrice = current + input;
    } else if (operation === 'minus') {
        // Prevent cart price from going below 0
        newCartPrice = Math.max(0, current - input);
    } else if (operation === 'set' || !operation) {
        // If `operation` is 'set' or invalid, just set to input
        newCartPrice = input;
    } else {
        // Unknown operation, do nothing or throw error if desired
        return;
    }
    
    localStorage.setItem('cartprice', newCartPrice);
}

export default updateCartPrice;
